import consumer from '../../../channels/consumer'

class ReportModelChannel {
  constructor(reportModelId) {
    this.setReportModelCableSubscription(reportModelId)
  }

  setReportModelCableSubscription(reportModelId) {
    consumer.subscriptions.create({ channel: 'Bi::ReportModelChannel', id: reportModelId }, {
      received(data) {
        const emission = document.querySelector(`#bi-report-emission-${reportModelId}`)
        if (emission) emission.innerHTML = data.emission_status

        const actions = document.querySelector(`#bi-report-actions-${reportModelId}`)
        if (actions) actions.innerHTML = data.actions
      },
    })
  }
}

export default ReportModelChannel
